import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { getProtectedResource } from "../../services/apiRequest.service";
import { NestedResponseData } from "../../models/responseData";
import {
  TransformedData,
  transformDataStackedByAnswer
} from "../../utils/transformDataUtils";
import FilterDropdown from "../../components/FilterDropdown";
import StackedByAnswer from "../../charts/stackedBarChart/stackedByAnswer";
import InstitutionN from "../../components/InstitutionN";
import PageLoader from "../../components/PageLoader";
import ApiResponseToCSVConverter from "../../utils/csvDownload/ApiResponseToCsvConverter";
import { determineResponseTypeNestedResponseData } from "../../utils/determineResponseType";


const Satisfaction = () => {
  const [selectedFilter, setSelectedFilter] = useState("exit_status");
  const [apiResponse, setApiResponse] = useState<NestedResponseData | null>(null);
  const [apiResponseStatistics, setApiResponseStatistics] = useState<NestedResponseData | null>(null);

  const [transformedResponse, setTransformedResponse] = useState<TransformedData[] | null>(null);
  const [institutionN, setInstitutionN] = useState(0);

  const { getAccessTokenSilently } = useAuth0();
  const { year } = useParams();

  useEffect(() => {
    const getData = async () => {
      const accessToken = await getAccessTokenSilently();
      const requestUrl = `section8/subsection2/?report_year=${year}&group_by=${selectedFilter}`;
      const { data, error } = await getProtectedResource(accessToken, requestUrl);

      if (data && determineResponseTypeNestedResponseData(data)) {
        setApiResponse(data);
        setTransformedResponse(transformDataStackedByAnswer(data, "8.2", selectedFilter));
        setInstitutionN(data.institution.total.total);
      }

      if (error) {
        console.error("Error fetching data:", error);
      }
    };

    const getDataStatistics = async () => {
      const accessToken = await getAccessTokenSilently();
      const requestUrl = `section8/subsection2/?report_year=${year}&group_by=${selectedFilter}&statistics=True`;
      const { data, error } = await getProtectedResource(accessToken, requestUrl);

      if (data && determineResponseTypeNestedResponseData(data)) {
        setApiResponseStatistics(data);
      }

      if (error) {
        console.error("Error fetching data:", error);
      }
    };

    getData();
    getDataStatistics();
  }, [getAccessTokenSilently, year, selectedFilter]);

  return (
    <>
      <h2>8.2 Satisfaction with retention efforts</h2>
      <p>
        Please rate your level of satisfaction or dissatisfaction with efforts made by your
        institution to retain you at the time those efforts were possible.
      </p>

      {!transformedResponse && <PageLoader />}

      {transformedResponse &&
        <>
          <InstitutionN institutionN={institutionN} />
          <FilterDropdown setSelectedFilter={setSelectedFilter} />
          <StackedByAnswer
            data={transformedResponse}
            section="8.2"
            sequential={true}
            institutionN={institutionN}
            selectedFilter={selectedFilter}
          />
          <ApiResponseToCSVConverter
            apiResponse={apiResponse}
            apiResponseB={apiResponseStatistics}
            selectedFilter={selectedFilter}
            filename="8.2_Satisfaction"
            section="8.2"
          />
        </>
      }

      
    </>
  )
}

export default Satisfaction;